module.exports = require("yargs");


//////////////////
// WEBPACK FOOTER
// external "yargs"
// module id = 84
// module chunks = 0